export default {
  default: () => import("/web/layouts/default.vue").then(m => m.default || m)
}